<template>
    <div class="course-container">
        <h2 class="title">Courses</h2>
        <div class="course-list" v-if="courses.length">
            <div v-for="course in courses" :key="course.id" class="course-card">
                <!-- 课程图片 -->
                <div class="course-image-container">
                    <!-- 如果有 course.image，就使用它 -->
                    <img v-if="course.image_url" @click="goToDetail(course)" :src="course.image_url" :alt="course.title"
                        class="course-image" />
                    <!-- 否则使用一张占位图（可换成你实际的占位图片地址） -->
                    <div v-else @click="goToDetail(course)">
                        <el-empty description="There is no cover picture" class="course-image"></el-empty>
                    </div>
                </div>
                <!-- 进度条 -->
                <el-progress :percentage="course.complation_rate" :stroke-width="6" color="#409eff" class="progress-bar"
                    :show-text="false"></el-progress>
                <!-- 课程信息 -->
                <h3 class="course-title">{{ course.name }}</h3>
                <p class="course-progress">
                    {{ course.complation_rate }}% <span class="bold-text"></span>
                </p>
            </div>
        </div>
        <div v-else>
            <el-empty description="unfound"></el-empty>
        </div>
    </div>
</template>

<script>
import { customerCoursesList } from "@/api/course";
export default {
    name: "curriculum-index",
    data() {
        return {
            courses: [
                // {
                //     id: 1,
                //     title: "Test Course",
                //     // image_url: "https://imgservice.suning.cn/uimg1/b2c/image/LQXoYigta_cZspLUsEtEqQ.jpg_800w_800h_4e",
                //     complation_rate: 0,
                // },
                // {
                //     id: 2,
                //     title: "Drip Course",
                //     image_url: "https://imgservice.suning.cn/uimg1/b2c/image/LQXoYigta_cZspLUsEtEqQ.jpg_800w_800h_4e",
                //     complation_rate: 33,
                // },
                // {
                //     id: 3,
                //     title: "Custom Course",
                //     image_url: "https://imgservice.suning.cn/uimg1/b2c/image/LQXoYigta_cZspLUsEtEqQ.jpg_800w_800h_4e",
                //     complation_rate: 0,
                // },
            ],
        };
    },
    created() {
        this.customerCoursesListApi()
    },
    methods: {
        async customerCoursesListApi() {
            const res = await customerCoursesList()
            this.courses = res.body.items
        },
        goToDetail(data) {
            if (data.published_at) {
                this.$router.push({ path: "/curriculum/detail", query: { id: data.id } });
            } else {
                this.$message({
                    message: 'Course not published',
                    type: 'warning'
                });
            }

        }
    }
};
</script>
<style scoped>
.course-container {
    padding: 20px;
    background-color: #f5f5f5;
    /* min-height: 100vh; */
}

.title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}

.course-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.course-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 16px;
    width: 240px;
    text-align: center;
}

.course-image {
    width: 100%;
    height: 260px;
    object-fit: cover;
    border-radius: 6px;
    cursor: pointer;
}

.progress-bar {
    margin: 12px 0;
}

.course-title {
    font-size: 16px;
    font-weight: bold;
    margin-top: 6px;
}

.course-progress {
    font-size: 14px;
    color: #666;
}

.bold-text {
    font-weight: bold;
}

.course-image-container {
    width: 100%;
    text-align: center;
    margin-bottom: 8px;
}
</style>